import { record } from '../browser/ophan/ophan';
import { initPerf } from '../browser/initPerf';
const recordMessageTimeoutInOphan = (candidateId, slotName) => record({
    component: `${slotName}-picker-timeout-dcr`,
    value: candidateId,
});
const timeoutify = (candidateConfig, slotName) => {
    let timer;
    const canShow = () => new Promise((resolve) => {
        const perfName = `messagePicker-canShow-${candidateConfig.candidate.id}`;
        const canShowTiming = initPerf(perfName);
        canShowTiming.start();
        if (candidateConfig.timeoutMillis) {
            timer = window.setTimeout(() => {
                recordMessageTimeoutInOphan(candidateConfig.candidate.id, slotName);
                resolve({ show: false });
            }, candidateConfig.timeoutMillis);
        }
        candidateConfig.candidate
            .canShow()
            .then((result) => {
            resolve(result);
            const canShowTimeTaken = canShowTiming.end();
            if (candidateConfig.reportTiming) {
                record({
                    component: perfName,
                    value: canShowTimeTaken,
                });
            }
        })
            .catch((e) => console.error(`timeoutify candidate - error: ${e}`));
    });
    const cancelTimeout = () => timer && clearTimeout(timer);
    return {
        ...candidateConfig,
        candidate: {
            ...candidateConfig.candidate,
            canShow,
        },
        cancelTimeout,
    };
};
const clearAllTimeouts = (messages) => messages.map((m) => m.cancelTimeout());
const defaultShow = () => null;
export const pickMessage = ({ candidates, name, }) => new Promise((resolve) => {
    const candidateConfigsWithTimeout = candidates.map((c) => timeoutify(c, name));
    const results = candidateConfigsWithTimeout.map((candidateConfig) => ({
        candidateConfig,
        canShow: candidateConfig.candidate.canShow(),
    }));
    const winnerResult = results.reduce(async (winningMessageSoFar, { candidateConfig, canShow }) => {
        if (await winningMessageSoFar) {
            return winningMessageSoFar;
        }
        const result = await canShow;
        candidateConfig.cancelTimeout();
        if (result.show) {
            return {
                candidate: candidateConfig.candidate,
                meta: result.meta,
            };
        }
        return winningMessageSoFar;
    }, Promise.resolve(null));
    winnerResult
        .then((winner) => {
        clearAllTimeouts(candidateConfigsWithTimeout);
        if (winner === null) {
            resolve(defaultShow);
        }
        else {
            const { candidate, meta } = winner;
            resolve(() => candidate.show(meta));
        }
    })
        .catch((e) => console.error(`pickMessage winner - error: ${e}`));
});
